import * as actionTypes from '../constants/actionType';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';


//Action Creators
export const loadMLatestNewsStart = () => {
  return {
    type: actionTypes.MLATESTNEWS_LOAD_START,
  };
};
export const loadMLatestNewsFail = (error) => {
  console.error(error);
  return {
    type: actionTypes.MLATESTNEWS_LOAD_FAIL,
    error,
  };
};
export const loadMLatestNewsSuccess = (data) => {
  return {
    type: actionTypes.MLATESTNEWS_LOAD_SUCCESS,
    data,
  };
};

const newsSortQuery = {
  '_sort': 'NewsDate:DESC',
};

/**
 * Project pages: only show news items explicitly linked to this project.
 * Empty results stay empty so the UI can render an empty-state message.
 */
export function loadNewsForRelatedProject(project) {
  if (!project?.id) {
    return Promise.resolve([]);
  }

  return apiActions.loadEndpoint(apiValues.nref.news.endpoint, null, {
    RelatedProject_in: project.id,
    ...newsSortQuery,
  });
}

export const initMLatestNews = params => dispatch => {
  dispatch(loadMLatestNewsStart());

  let newsPromise;
  if (params.relatedProgram) {
    newsPromise = apiActions.loadEndpoint(apiValues.nref.news.endpoint, null, {
      Program_in: params.relatedProgram.id,
      ...newsSortQuery,
    });
  } else if (params.relatedProject) {
    newsPromise = loadNewsForRelatedProject(params.relatedProject);
  } else if (params.relatedTag) {
    newsPromise = apiActions.loadEndpoint(apiValues.nref.news.endpoint, null, {
      Tags_in: params.relatedTag.id,
      ...newsSortQuery,
    });
  } else if (params.program && params.program.id) {
    newsPromise = apiActions.loadEndpoint(apiValues.nref.news.endpoint, null, {
      Program_in: params.program.id,
      ...newsSortQuery,
    });
  } else {
    newsPromise = apiActions.loadEndpoint(apiValues.nref.news.endpoint, null, newsSortQuery);
  }

  return newsPromise.then(results => {
    let mLatestNews = {news: results ? apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.news.fieldsUsed) : []};
    dispatch(loadMLatestNewsSuccess(mLatestNews));
    return mLatestNews;
  });
};
